<div class="container">
    <div class="container" id="paper">
        <p class="text" *ngFor="let text of texts">{{text}}</p>
    </div>
</div>